import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
 * shift-jisの範囲内のみ許可するクラス
 */
export default class SJISStringConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを取り除く
        const str = target.value.removeControlCode();

        // shift-jis以外を取り除く
        return str.removeNotSJIS();
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを取り除く(TextAreaのため改行コードは取り除かない)
        const str = target.value.removeControlCodeAllowNewLine();

        // shift-jis以外を取り除く
        return str.removeNotSJIS();
    }
}